import API from "./api";
import * as routes from './_routes';

export function fetchTimezoneList(bodyFormData) {
    return API.get(routes.TIMEZONES_LIST);
}
